export const TimerOrientation = {
  Horizontal: 'horizontal',
  Vertical: 'vertical'
} as const

export type TimerOrientation = (typeof TimerOrientation)[keyof typeof TimerOrientation]
